<p-toolbar>
  <ng-template #start>
    <div class="taxora-logo w-full mx-auto px-6 lg:px-12 flex justify-between w-full items-center">
      <div class="flex items-center gap-4">
        <img src="assets/images/logos/taxora-logo.svg" alt="TAXORA LOGO" class="taxora-logo" />
        @if (isToggleVisible()) {
          <button
            pButton
            type="button"
            text
            rounded
            class="header-toggle-button"
            [pTooltip]="toggleTooltip()"
            tooltipPosition="bottom"
            (click)="onToggle()"
          >
            <i class="pi" [class.pi-bars]="isToggled()" [class.pi-angle-left]="!isToggled()"></i>
          </button>
        }
      </div>
    </div>
  </ng-template>
  <ng-template #end>
    <ng-content />
  </ng-template>
</p-toolbar>
